jQuery(document).ready(function($) {

  $('.a-hamburger').click(function() {
    const isToggled = $(this).hasClass('a-hamburger--toggled');

    $(this).toggleClass('a-hamburger--toggled');
    $(this).attr('aria-expanded', isToggled ? 'false' : 'true');
  });

});